// Parse images - check witei_images first, then display_images as fallback
export const parseListingImages = (imageData: unknown): string[] => {
  if (!imageData) {
    return []
  }

  try {
    let jsonArray;

    // Handle if it's a string (needs parsing)
    if (typeof imageData === 'string') {
      const cleanedJsonString = imageData.replace(/:\s*NaN/g, ': null');
      jsonArray = JSON.parse(cleanedJsonString);
    } else if (Array.isArray(imageData)) {
      // Already an array
      jsonArray = imageData;
    } else if (typeof imageData === 'object' && imageData !== null) {
      // It's an object, try to stringify and parse (handles Supabase JSON type)
      const stringified = JSON.stringify(imageData).replace(/:\s*NaN/g, ': null');
      jsonArray = JSON.parse(stringified);
    } else {
      return []
    }

    // Extract URLs
    if (Array.isArray(jsonArray)) {
      const images = jsonArray
        .map((image: unknown) => {
          // If it's already a string URL, return it
          if (typeof image === 'string') {
            return image;
          }

          // If it's an object, try multiple possible property names
          if (typeof image === 'object' && image !== null) {
            const img = image as Record<string, unknown>;
            // Try different possible property names
            return img["URL de Imagen"] || img["url"] || img["URL"] || img["image_url"] || img["imageUrl"] || img["src"] || img["link"];
          }

          return null;
        })
        .filter((url): url is string => Boolean(url) && typeof url === 'string');

      return images;
    }

    // If it's an object, check if it has an "images" property that is an array
    if (typeof jsonArray === 'object' && jsonArray !== null && !Array.isArray(jsonArray)) {
      const obj = jsonArray as Record<string, unknown>;

      // Check for "images" property
      if (obj.images && Array.isArray(obj.images)) {
        const images = obj.images
          .map((image: unknown) => {
            if (typeof image === 'string') {
              return image;
            }
            return null;
          })
          .filter((url): url is string => Boolean(url) && typeof url === 'string');

        return images;
      }

      // Try other possible property names
      const possibleKeys = ['imageUrls', 'image_urls', 'urls', 'photos', 'pictures'];
      for (const key of possibleKeys) {
        if (obj[key] && Array.isArray(obj[key])) {
          const images = (obj[key] as unknown[])
            .map((image: unknown) => {
              if (typeof image === 'string') {
                return image;
              }
              return null;
            })
            .filter((url): url is string => Boolean(url) && typeof url === 'string');

          return images;
        }
      }
    }

    return []
  } catch {
    return []
  }
}
